import { gql, useMutation } from '@apollo/client';
import { apolloClient } from '../apollo/client';

export const CRIAR_COMENTARIO = gql`
    mutation CriarComentario($input: ComentarioInput!) {
        criarComentario(input: $input) {
            id
            criadoEm
            texto
            curtidasCount
            jaCurtiu
            autorAtleta {
                id
                usuario {
                    id
                    nome
                    imagemUrl
                }
            }
            autorTorneio {
                avatarUrl
                id
                nome
            }
            autorLiga {
                id
                nome
                imagemUrl
                username
            }
        }
    }
`;

export function useCriarComentario() {
  return useMutation(CRIAR_COMENTARIO);
}

export const DELETAR_COMENTARIO = gql`
    mutation DeletarComentario($id: ID!) {
        deletarComentario(id: $id)
    }
`;

export function useDeletarComentario() {
  return useMutation(DELETAR_COMENTARIO);
}

export async function deletarComentario(comentarioId: string): Promise<void> {
  await apolloClient.mutate({
    mutation: DELETAR_COMENTARIO,
    variables: { id: comentarioId },
  });
}
